import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=4194c4ae&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=ts"
export * from "./ReportCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=4194c4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4194c4ae",
  null
  
)

export default component.exports